import parse from "html-react-parser";
import React, { useState } from "react";
import Chatbot from "../Chatbot/Chatbot";

import { contactSupportMobile } from "../../assets/images/icons";
import { navigateToURL } from "../../bridges/BridgeServices";
import "./mobileContactSupport.scss";

import { close } from "../../assets/images/icons";

const MobileContactSupport = supportBtnClassName => {
  const [shouldOpenChatbot, setOpenChatbot] = useState(
    false
  );

  return (
    <>
      <div
        className="support-close-icon hide"
        onClick={() => {
          setOpenChatbot(false);
          document
            .getElementById("mobile-chat-container")
            .click();

          if (document) {
            document.getElementsByClassName(
              "support-close-icon"
            )[0].style.display = "none";
            document
              .getElementsByClassName(
                "support-close-icon"
              )[0]
              .classList.add("hide");
          }
        }}
      >
        {parse(close)}
      </div>
      <button
        className={`support-button-mobile ${
          supportBtnClassName.supportBtnClassName ?? ""
        }`}
        style={{ display: "flex" }}
        onClick={() => {
          navigateToURL("CHATBOT");
        }}
      >
        {parse(contactSupportMobile)}
        <div className={"support-button-content"}>
          <p>Raise Ticket</p>
        </div>
      </button>
      <Chatbot shouldOpenChatbot={shouldOpenChatbot} />
    </>
  );
};

export default MobileContactSupport;
